import { IProductDetail } from '@/api/types/public';
import { useTranslations } from '@/i18n/use-translations';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import SizeGuide from '../SizeGuide';

export const ProgressiveContent = ({
  paragraphClassName = '',
}: {
  paragraphClassName?: string;
}) => {
  const t = useTranslations('goodsDetail.progressive');

  return (
    <div className="">
      <p className={paragraphClassName}>{t('description1')}</p>
      <p className={paragraphClassName}>{t('description2')}</p>
      <p className={paragraphClassName}>{t('description3')}</p>
    </div>
  );
};

export const RxRangeContent = ({ paragraphClassName = '' }: { paragraphClassName?: string }) => {
  const t = useTranslations('goodsDetail.rxRange');
  return (
    <div className="">
      <div className={`${paragraphClassName} `}>
        <p className={`font-bb mb-12 text-14`}>{t('title')}</p>
        <p>{t('description')}</p>
      </div>
      <div className={`${paragraphClassName} mt-12`}>
        <p className={`font-bb mb-12 text-14`}>{t('noteTitle')}</p>
        <p>{t('noteDescription')}</p>
      </div>
    </div>
  );
};

export const PdRangeContent = ({ paragraphClassName = '' }: { paragraphClassName?: string }) => {
  const t = useTranslations('goodsDetail.pdRange');
  const router = useRouter();
  const jumpToMeasurePD = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    router.push('/guide-tips/measure-PD');
  };
  return (
    <div className="">
      <p className={paragraphClassName}>{t('description1')}</p>
      <p className={paragraphClassName}>
        {t('description2')}&nbsp;
        <Link
          prefetch={false}
          href="/guide-tips/measure-PD"
          className="text-primary-purple underline"
          onClick={jumpToMeasurePD}
        >
          {t('measureLink')}
        </Link>
      </p>
    </div>
  );
};

export const renderSizeContent = (detail: IProductDetail) => (
  <SizeGuide detail={detail} show onClose={() => {}} />
);

export const BridgeFitContent = ({
  paragraphClassName = '',
  detail,
}: {
  paragraphClassName?: string;
  detail: IProductDetail;
}) => {
  const t = useTranslations('goodsDetail.bridgeFit');
  const bridgeFitObj = {
    'Universal Fit': t('description'),
    'Low Fit': t('description2'),
  };
  return (
    <div className="">
      <p className={paragraphClassName}>
        {bridgeFitObj[detail.frame_bridge_value as keyof typeof bridgeFitObj]}
      </p>
    </div>
  );
};

export const TITLES = {
  PROGRESSIVE: 'Progressive',
  RX_RANGE: 'Rx Range',
  PD_RANGE: 'PD (Pupillary Distance)',
  SIZE: 'Our Frame Sizes',
} as const;
